(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "68e8b11d0e8b65ad5205d722";
              window.beaePageSetting.pageTitle = "footer menu"; 
              window.beaePageSetting.pageType = "footer";

          let js_3AGH8NBF = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-sodyhajnsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-sodyhajn',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-sodyhajn');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-sodyhajn: ', ex)
      };
    

      try {
        let argid = 'beae-pzhjk8tnblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-pzhjk8tn',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-pzhjk8tn');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-pzhjk8tn: ', ex)
      };
    

      try {
        let argid = 'beae-1nizb20pblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-1nizb20p',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-1nizb20p');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-1nizb20p: ', ex)
      };
    

      try {
        let argid = 'beae-ug8flq1hlinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ug8flq1h',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ug8flq1h');
        args.el = args.els[0];
        ((f) => { const b=f.el.querySelector(".beae-linkslist-title"),k=f.el.querySelector(".beae-linkslist");b===null||k===null||b.addEventListener("click",g=>{window.matchMedia("(max-width: 767px)").matches&&k.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ug8flq1h: ', ex)
      };
    

      try {
        let argid = 'beae-ngb9hh43linkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ngb9hh43',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ngb9hh43');
        args.el = args.els[0];
        ((f) => { const b=f.el.querySelector(".beae-linkslist-title"),k=f.el.querySelector(".beae-linkslist");b===null||k===null||b.addEventListener("click",g=>{window.matchMedia("(max-width: 767px)").matches&&k.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ngb9hh43: ', ex)
      };
    

      try {
        let argid = 'beae-xfdrxmqvlinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-xfdrxmqv',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-xfdrxmqv');
        args.el = args.els[0];
        ((f) => { const b=f.el.querySelector(".beae-linkslist-title"),k=f.el.querySelector(".beae-linkslist");b===null||k===null||b.addEventListener("click",g=>{window.matchMedia("(max-width: 767px)").matches&&k.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-xfdrxmqv: ', ex)
      };
    

      try {
        let argid = 'beae-d2t9z90yblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-d2t9z90y',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-d2t9z90y');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-d2t9z90y: ', ex)
      };
    

      try {
        let argid = 'beae-pfi3ynhsblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-pfi3ynhs',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-pfi3ynhs');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-pfi3ynhs: ', ex)
      };
    

      try {
        let argid = 'beae-kpv122jglc-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-kpv122jg',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-kpv122jg');
        args.el = args.els[0];
        ((m) => { let h=m.checkLive;function p(_){return{input:_.querySelector('input[name="locale_code"], input[name="country_code"]'),button:_.querySelector("button.beae-current-value"),panel:_.querySelector(".beae-language-results"),search:_.querySelector('input[name="language_filter"]'),resetButton:_.querySelector(".beae-reset-button")}}function f(_,M){const V=m.el.querySelector("form.beae-localization");M.input.value=_.currentTarget.dataset.value,V&&V.submit()}function b(_){_.button.focus(),_.panel.classList.toggle("hidden-dropdown"),_.button.setAttribute("aria-expanded",(_.button.getAttribute("aria-expanded")==="false").toString());const M=_.button.getBoundingClientRect();window.innerHeight-M.bottom<_.panel.offsetHeight?(_.panel.style.top="auto",_.panel.style.bottom="100%"):(_.panel.style.top="100%",_.panel.style.bottom="auto")}function k(_){return _.normalize("NFD").replace(/\p{Diacritic}/gu,"").toLowerCase()}function g(_,M){const V=k(M.search.value),L=_.querySelectorAll(".beae-languages li");L.length,M.resetButton.classList.toggle("hidden",!V),L.forEach(T=>{k(T.querySelector(".beae-language-name").textContent).indexOf(V)>-1?T.classList.remove("beae-hidden"):T.classList.add("beae-hidden")})}function v(_){_.code.toUpperCase()==="ENTER"&&_.preventDefault()}function S(_,M,V){_.stopPropagation(),V.search.value="",g(M,V)}function B(_,M,V){(!M.contains(_.target)||!M.contains(_.relatedTarget))&&(C(M,V),V.button.setAttribute("aria-expanded",(V.button.getAttribute("aria-expanded")==="false").toString()))}function C(_,M){M.panel.classList.add("hidden-dropdown"),M.search&&(M.search.value="",g(_,M))}function $(_){const M=p(_);h&&_.addEventListener("focusout",V=>B(V,_,M)),M.button.addEventListener("click",()=>b(M)),_.querySelectorAll(".beae-language-name").forEach(V=>V.addEventListener("click",L=>f(L,M))),M.search&&(M.search.addEventListener("keyup",()=>g(_,M)),M.search.addEventListener("keydown",v)),M.resetButton&&(M.resetButton.addEventListener("click",V=>S(V,_,M)),M.resetButton.addEventListener("mousedown",V=>V.preventDefault()))}m.el.querySelectorAll(".beae-localization").forEach($) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-kpv122jg: ', ex)
      };
    

      try {
        let argid = 'beae-wqh4v6l1lc-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-wqh4v6l1',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-wqh4v6l1');
        args.el = args.els[0];
        ((x) => { let m=x.checkLive;function h(w){return{input:w.querySelector('input[name="locale_code"], input[name="country_code"]'),button:w.querySelector("button.beae-current-value"),panel:w.querySelector(".beae-country-results"),search:w.querySelector('input[name="country_filter"]'),resetButton:w.querySelector(".beae-reset-button")}}function p(w,_){const M=x.el.querySelector("form.beae-localization");_.input.value=w.currentTarget.dataset.value,M&&M.submit()}function f(w){w.button.focus(),w.panel.classList.toggle("hidden-dropdown"),w.button.setAttribute("aria-expanded",(w.button.getAttribute("aria-expanded")==="false").toString());const _=w.button.getBoundingClientRect();window.innerHeight-_.bottom<w.panel.offsetHeight?(w.panel.style.top="auto",w.panel.style.bottom="100%"):(w.panel.style.top="100%",w.panel.style.bottom="auto")}function b(w){return w.normalize("NFD").replace(/\p{Diacritic}/gu,"").toLowerCase()}function k(w,_){const M=b(_.search.value),V=w.querySelectorAll(".beae-countries li");V.length,_.resetButton.classList.toggle("hidden",!M),V.forEach(L=>{b(L.querySelector(".beae-country-name").textContent).indexOf(M)>-1?L.classList.remove("beae-hidden"):L.classList.add("beae-hidden")})}function g(w){w.code.toUpperCase()==="ENTER"&&w.preventDefault()}function v(w,_,M){w.stopPropagation(),M.search.value="",k(_,M)}function S(w,_,M){(!_.contains(w.target)||!_.contains(w.relatedTarget))&&(B(_,M),M.button.setAttribute("aria-expanded",(M.button.getAttribute("aria-expanded")==="false").toString()))}function B(w,_){_.panel.classList.add("hidden-dropdown"),_.search&&(_.search.value="",k(w,_))}function C(w){const _=h(w);m&&w.addEventListener("focusout",M=>S(M,w,_)),_.button.addEventListener("click",()=>f(_)),w.querySelectorAll(".beae-country-name").forEach(M=>M.addEventListener("click",V=>p(V,_))),_.search&&(_.search.addEventListener("keyup",()=>k(w,_)),_.search.addEventListener("keydown",g)),_.resetButton&&(_.resetButton.addEventListener("click",M=>v(M,w,_)),_.resetButton.addEventListener("mousedown",M=>M.preventDefault()))}x.el.querySelectorAll(".beae-localization").forEach(C) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-wqh4v6l1: ', ex)
      };
    

      try {
        let argid = 'beae-btmvlmflblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-btmvlmfl',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-btmvlmfl');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-btmvlmfl: ', ex)
      };
    

      try {
        let argid = 'beae-t6tzaswbblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-t6tzaswb',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-t6tzaswb');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-t6tzaswb: ', ex)
      };
    

      try {
        let argid = 'beae-ybxyfvqhsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ybxyfvqh',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ybxyfvqh');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ybxyfvqh: ', ex)
      };
    

      try {
        let argid = 'beae-0aikvwu0block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-0aikvwu0',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-0aikvwu0');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-0aikvwu0: ', ex)
      };
    

      try {
        let argid = 'beae-lonuppjvblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-lonuppjv',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-lonuppjv');
        args.el = args.els[0];
        ((M) => { var P;if(M.el){if(M.shape){const O=M.el.closest(".beae-slider-items");O&&!O.hasAttribute("data-svg")&&(O==null||O.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),O.setAttribute("data-svg","true"))}let H=M.el.querySelector(".beae-image-content-position"),I,z=window.innerWidth>=768&&M.autoHover;var V=H.querySelector(".beae-img-ratio-control"),L=H.querySelector(".beae-img-comp-container"),T=H.querySelector(".beae-img-comp-container--second");if(V&&T){let O=function(A){let D=0,Z;q(),z?H.onmouseover=function(G){W(G)}:A.onmousedown=function(G){W(G)},H.onmouseup=function(){j()},A.ontouchstart=function(G){W(G)},H.ontouchend=function(){j()};function q(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),A.style.left&&parseInt(A.style.left)}function W(G){check=!1,G.preventDefault(),G.clientX?G.clientX:G.touches[0].clientX,parseInt(A.style.left),D=1,H.onmousemove=function(K){R(K)},H.ontouchmove=function(K){R(K)}}function j(){D=0,check=!0}function R(G){if(D==0)return!1;Z=U(G),Z<0&&(Z=0),Z>100&&(Z=100),F(Z)}function U(G){const K=H.getBoundingClientRect(),oe=(G.changedTouches?G.changedTouches[0].clientX:G.clientX)-K.left;return Math.max(0,Math.min(100,Math.round(oe*100/I)))}function F(G){A.style.left=G+"%",T.style.clipPath=`polygon(${G}% 0%, ${G}% 100%, 100% 100%, 100% 0)`,L.style.clipPath=`polygon(0% 100%, 0% 0%, ${G}% 0%, ${G}% 100%)`}};V&&T&&O(V),window.addEventListener("resize",function(){V&&T&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),O(V))})}}let N=(P=M.el)==null?void 0:P.querySelector("a.beae-x-image"),E=N==null?void 0:N.getAttribute("href");N&&M.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&N.addEventListener("click",H=>{let I=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(I)return I.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),H.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-lonuppjv: ', ex)
      };
    }; if (window.BEAEBASE) {js_3AGH8NBF()} else {window.BEAEPAGEJS.push(js_3AGH8NBF)} })(); 